// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2ZGZG","header":"PatientBlock_header__3Byml","label":"PatientBlock_label__1QJtr","option":"PatientBlock_option__IFZ_6"};